// extracted by mini-css-extract-plugin
export default {"root":"SerpPresenceTable_root__7Wmzu","headless":"SerpPresenceTable_headless__yzNgJ","header":"SerpPresenceTable_header__DC9So","title":"SerpPresenceTable_title__b4C4b"};